import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

let supabase;

if (!supabaseUrl || !supabaseKey || supabaseUrl.includes('your-project') || supabaseKey.includes('your_supabase')) {
  console.warn('⚠️ Supabase not configured properly. Using fallback mode.');
  console.warn('Please update your .env file with real Supabase credentials:');
  console.warn('REACT_APP_SUPABASE_URL=https://your-project.supabase.co');
  console.warn('REACT_APP_SUPABASE_ANON_KEY=your_real_anon_key');
  
  // Create a fallback client that provides helpful error messages
  supabase = {
    from: (table) => ({
      select: () => {
        console.error(`Cannot query ${table} table: Supabase not configured`);
        return Promise.resolve({ data: [], error: null });
      },
      insert: () => {
        console.error(`Cannot insert into ${table} table: Supabase not configured`);
        return Promise.reject(new Error('Supabase not configured. Please set up your .env file with real credentials.'));
      },
      eq: function() { return this; },
      single: function() { return this; },
      order: function() { return this; }
    }),
    storage: {
      from: () => ({
        upload: () => Promise.reject(new Error('Supabase storage not configured')),
        getPublicUrl: () => ({ data: { publicUrl: '' } })
      })
    }
  };
} else {
  try {
    supabase = createClient(supabaseUrl, supabaseKey);
    console.log('✅ Supabase client initialized successfully');
  } catch (error) {
    console.error('❌ Error initializing Supabase client:', error);
    throw error;
  }
}

export { supabase };